import React, { useMemo, useState } from 'react';
import { Field, Text, Area, File, RepeatList, useEmit } from './fields';

const blank = () => ({
    ContractorName: '', ContractorMobile: '', ContractorEmail: '', ContractorAddress: '',
    LicenseNo: '', LicenseIssueLocation: '', LicenseIssueDate: '', LicenseExpiryDate: '',
    LicenseAttachment: '', Comments: '',
});

/** Emits an array of contractor objects (LicenseAttachment = filename only). */
const ContractorDetails = ({ onDataChange }) => {
    const [rows, setRows] = useState([blank()]);

    const data = useMemo(() => rows, [rows]);
    useEmit(data, onDataChange);

    const set = (i, key, val) => setRows((prev) => prev.map((r, idx) => idx === i ? { ...r, [key]: val } : r));
    const add = () => setRows((prev) => [...prev, blank()]);
    const remove = (i) => setRows((prev) => prev.filter((_, idx) => idx !== i));
    const clear = (i) => setRows((prev) => prev.map((r, idx) => idx === i ? blank() : r));

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Contractor Details</h6></div>
            <RepeatList
                title="Contractor" items={rows} onAdd={add} onRemove={remove} onClear={clear}
                addLabel="Add Another Contractor"
                renderRow={(c, i) => (
                    <div className="v3-wp-grid">
                        <Field label="Contractor Full Name"><Text value={c.ContractorName} onChange={(v) => set(i, 'ContractorName', v)} placeholder="Full name" /></Field>
                        <Field label="Mobile"><Text value={c.ContractorMobile} onChange={(v) => set(i, 'ContractorMobile', v)} placeholder="971-xx-xxxxxxx" /></Field>
                        <Field label="Email"><Text type="email" value={c.ContractorEmail} onChange={(v) => set(i, 'ContractorEmail', v)} placeholder="name@example.com" /></Field>
                        <Field label="Address / Company"><Text value={c.ContractorAddress} onChange={(v) => set(i, 'ContractorAddress', v)} placeholder="Address" /></Field>
                        <Field label="License No"><Text value={c.LicenseNo} onChange={(v) => set(i, 'LicenseNo', v)} /></Field>
                        <Field label="License Issue Location"><Text value={c.LicenseIssueLocation} onChange={(v) => set(i, 'LicenseIssueLocation', v)} /></Field>
                        <Field label="License Issue Date"><Text type="date" value={c.LicenseIssueDate} onChange={(v) => set(i, 'LicenseIssueDate', v)} /></Field>
                        <Field label="License Expiry Date"><Text type="date" value={c.LicenseExpiryDate} onChange={(v) => set(i, 'LicenseExpiryDate', v)} /></Field>
                        <Field label="License Attachment" full><File accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={(f) => set(i, 'LicenseAttachment', f ? f.name : '')} /></Field>
                        <Field label="Comments" full><Area value={c.Comments} onChange={(v) => set(i, 'Comments', v)} rows={2} /></Field>
                    </div>
                )}
            />
        </div>
    );
};

export default ContractorDetails;
